import { createFileRoute } from '@tanstack/react-router'

import { roomFiltersSchema, RoomsListView } from '@/modules/rooms'

export const Route = createFileRoute('/_auth/rooms/')({
  component: () => <RoomsListView />,
  validateSearch: roomFiltersSchema
})
